import React from "react";
import { createPortal } from "react-dom";

// Creator settings must escape the live stage's nested stacking contexts.
// Mounting them on document.body keeps chat, reactions, and video transforms
// from painting over interactive camera or audio controls.
const CreatorSettingsPortal = ({ children }) => {
  if (typeof document === "undefined" || !document.body) return null;
  return createPortal(children, document.body);
};

export default CreatorSettingsPortal;
